import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Trans } from 'react-i18next';

import useCompatibleDisplay from 'Util/Hooks/useCompatibleDisplay';
import { ButtonFilled, ButtonText, Flex, Text } from 'Components/Base';
import { Modal } from 'Components/Modal';

const StyledButtonText = styled((props) => (
  <ButtonText color={'secondary'} fontWeight={600} borderRadius={300} {...props} />
))`
  ${({ theme }) => css`
    &:hover {
      text-decoration: none;
      color: ${theme.colors.greyscale.grey3};
    }
  `}
`;

const ConfirmModal = ({
  muiProps,
  titleText = 'ยืนยันหรือไม่ ?',
  secondaryText = 'ยกเลิก',
  primaryText = 'ยืนยัน',
  contentText = 'เมื่อยืนยันแล้ว ไม่สามารถยกเลิกได้',
  primaryOnClick,
  disabledPrimaryButton = false,
  icon,
}) => {
  const { isMobile } = useCompatibleDisplay();
  const {
    onClose: secondaryOnClick,
    isActive,
    innerProps,
    modalPaperStyle,
    ...restMuiProps
  } = muiProps;
  const handleCloseModal = () => {
    secondaryOnClick();
  };
  const handleConfirm = () => {
    primaryOnClick();
  };

  return (
    <Modal
      muiProps={{
        isActive,
        modalPaperStyle: { margin: isMobile ? 16 : 32, ...modalPaperStyle },
        innerProps: { padding: 6, ...innerProps },
      }}
      contentWrapperProps={{ padding: '0px !important' }}
      disableTopOffset
      header={
        <Flex alignItems="center" flexDirection="column" gridRowGap={6}>
          {icon}
          <Text fontSize={5} fontWeight={600}>
            {titleText}
          </Text>
        </Flex>
      }
      contents={
        <Text mt={6}>
          <Trans defaults={contentText} components={[<br key="subtitle" />]} />
        </Text>
      }
      footer={
        <Flex
          justifyContent="flex-end"
          gridRowGap={6}
          padding={isMobile ? 6 : 7}
          style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}
          flexDirection="column"
        >
          <ButtonFilled
            color={'primary'}
            onClick={handleConfirm}
            fontWeight={600}
            borderRadius={300}
            disabled={disabledPrimaryButton}
          >
            {primaryText}
          </ButtonFilled>
          <StyledButtonText onClick={handleCloseModal}>{secondaryText}</StyledButtonText>
        </Flex>
      }
      {...restMuiProps}
    />
  );
};

ConfirmModal.propTypes = {
  ...Modal.propTypes,
  titleText: PropTypes.string,
  secondaryText: PropTypes.string,
  primaryText: PropTypes.string,
  contentText: PropTypes.string,
  primaryOnClick: PropTypes.func,
  disabledPrimaryButton: PropTypes.bool,
};

export default ConfirmModal;
